import { NextSeo } from 'next-seo';
import OnboardingLayout from '@c/layouts/OnboardingLayout';
import LoginOrSignupPage from '@c/LoginOrSignupPage';

const SignupPage = () => {
  return (
    <>
      <NextSeo
        title="Sign Up - GearFocus"
        noindex={true}
        nofollow={true}
      />
      <LoginOrSignupPage />
    </>
  );
};

SignupPage.getLayout = function getLayout(page: React.ReactElement) {
  return <OnboardingLayout>{page}</OnboardingLayout>;
};

export default SignupPage;
